module.exports = ".mat-form-field {\n  width: 40%;\n}\n\n.mat-dialog-content {\n  margin: 10px;\n}"